import { Grid } from "@mui/material";
import React, { useCallback, useState } from "react";
import EmailFilterForm from "../components/email/EmailFilterForm";
import EmailFilterModel from "../core/api/email/EmailFilterModel";
import BatchEmailModel from "../core/api/email/BatchEmailModel";
import EmailRecipientsTable from "../components/email/EmailRecipientsTable";
import PageRequest from "../core/api/PageRequest";
import EmailStatisticsTable from "../components/statistics/EmailStatisticsTable";
import { FilterDrawer } from "../components/common/FilterDrawer";

const defaultFilter: EmailFilterModel = {
  dateFrom: "",
  dateTo: "",
  user: "",
  status: "",
  email: "",
  clientId: "",
  opened: "",
};

export const EmailStatistics: React.FC = () => {
  const [filter, setFilter] = useState<EmailFilterModel>(defaultFilter);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const handleFilterToggle = useCallback(() => {
    setIsFilterOpen(prev => !prev);
  }, []);

  const handleFilterChange = useCallback((newFilter: EmailFilterModel) => {
    setFilter(prevFilter => ({ ...prevFilter, ...newFilter }));
  }, []);

  const fetchFn = useCallback(
    (page: PageRequest) => {
      return BatchEmailModel.allEmailRecipients(page, filter as unknown as Record<string, unknown>);
    },
    [filter]
  );

  const mainContent = (
    <Grid container spacing={3} justifyContent="center" direction="column">
      <Grid size="grow">
        <EmailRecipientsTable fetchFunction={fetchFn} />
      </Grid>
      <Grid size="grow">
        <EmailStatisticsTable filter={filter} />
      </Grid>
    </Grid>
  );

  const filterContent = (
    <EmailFilterForm
      filter={filter}
      onFilterChange={handleFilterChange}
    />
  );

  return (
    <FilterDrawer
      open={isFilterOpen}
      onToggle={handleFilterToggle}
      filterContent={filterContent}
    >
      {mainContent}
    </FilterDrawer>
  );
};
